<template>
  <div>
    <q-select
      v-model="operacao"
      :options="listaOperacao"
      class="input-mobile"
      dense
      outlined
      hide-selected
      fill-input
      option-label="nome"
      behavior="menu"
      label="Selecione a Operação"
      label-color="grey-6"
      @input-value="setModel"
      @blur="esconderSelect"
      @filter="filtrarOperacao"
      use-input
    />
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  props: ["model", "resetar", "habilitadoEnvio", "catalogoUuid"],
  emits: ["enviarOperacao", "fecharSelecao"],
  setup(props, { emit }) {
    const store = useStore();

    const operacao = ref(props.model);
    const listaOperacao = ref([]);

    const listarOperacao = async (val) => {
      await store.state.ferramentaria.catalogoUuid;
      try {
        const response = await store.dispatch("ferramentaria/listarOperacao", {
          catalogoUuid:
            props.catalogoUuid || store.state.ferramentaria.catalogoUuid,
          nome: val,
        });
        listaOperacao.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const esconderSelect = () => {
      emit("fecharSelecao");
    };

    watch(
      () => props.resetar,
      () => {
        operacao.value = "";
      }
    );

    watch(
      () => props.model,
      () => {
        if (operacao.value?.nome === props?.model?.nome) {
          return;
        }
        operacao.value = props.model;
      }
    );

    watch(
      () => operacao.value,
      () => {
        emit("enviarOperacao", {
          nome: operacao.value?.nome,
          transferenciaOperacaoUuid: operacao.value?.transferenciaOperacaoUuid,
        });
      }
    );

    return {
      operacao,
      listaOperacao,
      listarOperacao,
      esconderSelect,
      setModel(val) {
        if (val === "") {
          operacao.value = val;
        }
      },
      filtrarOperacao(val, update) {
        listarOperacao(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input-mobile {
    font-size: 12px;
  }
}
</style>
